export default __webpack_public_path__ + "static/media/help.7b1fc84b.svg";